import { render, staticRenderFns } from "./EditorWindow.vue?vue&type=template&id=350e42aa&scoped=true&"
import script from "./EditorWindow.vue?vue&type=script&lang=ts&"
export * from "./EditorWindow.vue?vue&type=script&lang=ts&"
import style0 from "./EditorWindow.vue?vue&type=style&index=0&id=350e42aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e42aa",
  null
  
)

export default component.exports